export interface PriceRange {
  min: number | null;
  max: number | null;
}

export interface SpecFilter {
  field: string;
  value: string;
}

export type BrowseViewMode = "table" | "grid";

export type ListingIntentFilter = "all" | "recycle";

export const LISTING_INTENT_OPTIONS: ReadonlyArray<{
  value: ListingIntentFilter;
  label: string;
}> = [
  { value: "all", label: "All listings" },
  { value: "recycle", label: "Free pickups" },
];
